/**
 * The words of a name that initials may come from, each reduced to its letters and numbers
 * (`ORG-031`, TW 44578815).
 *
 * "Ten24 - The Party Managers" drew **T-** because the dash was a word. A word with no letter or
 * number in it is dropped, and the rest lose their punctuation, so "(RI)" gives "RI" and never
 * "(R". Every helper that draws initials starts from this.
 */
export function initialWords(name) {
    return name
        .split(/\s+/u)
        .map((word) => word.replace(/[^\p{L}\p{N}]/gu, ''))
        .filter((word) => word.length > 0);
}
/**
 * **An organization's initials, one rule everywhere** (`ORG-031` AC-2): the first letter or number
 * of its first two words, or a one-word name's first two letters or numbers. The gradient mark,
 * the console's initials tile and the event pages' host initials all draw this, so "Ten24 - The
 * Party Managers" is **TT** on its page, its tile and its events alike.
 *
 * Sumit, 2026-10-30, on #1002: one organization must not show **TT** on its page and tile and
 * **TM** on event pages, which is what the event pages' first-and-last rule had drawn.
 *
 * Empty for a name with no letter or number in it; an organization's name can't be blank, and
 * each caller decides what an empty tile shows. A person's initials are `Avatar`'s, not this.
 */
export function organizationInitials(name) {
    const words = initialWords(name);
    if (words.length === 1)
        return (words[0] ?? '').slice(0, 2).toUpperCase();
    return words
        .slice(0, 2)
        .map((word) => word.charAt(0))
        .join('')
        .toUpperCase();
}
//# sourceMappingURL=initials.js.map